import {
  Component,
  OnDestroy,
  OnInit,
  Input,
  ChangeDetectorRef,
} from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import {
  groceryCategoryList,
  kitchenSearchItem,
  shoppingListItem,
  shoppingListItemInCategory,
} from 'src/app/core/model/api-response/cooking-story-model';
import { FoodModel } from 'src/app/core/model/object/diet-food-model';
import { CookingStoryGroceryService } from 'src/app/data/repository/cooking-story/cooking-story-grocery.service';
import { CookingStoryShoppinglistDateService } from 'src/app/data/repository/cooking-story/cooking-story-shoppinglist-date.service';
import { RecipeService } from 'src/app/data/repository/recipe-repository/recipe.service';
import Num2persian from 'num2persian';
import { KitchenQuickBottomsheetComponent } from './kitchen-quick-bottomsheet/kitchen-quick-bottomsheet.component';
import { foodUnitRatioArraySample } from 'src/app/core/model/api-response/persoanl-response-model';
import { ShoppingListSearchEditComponent } from './shoppinglist-search/shopping-list-search-edit/shopping-list-search-edit.component';
import { Subscription } from 'rxjs';
import { ShoppinglistMoveConfirmComponent } from './shoppinglist-move-confirm/shoppinglist-move-confirm.component';
import { AnimationOptions } from 'ngx-lottie';
import { AnimationItem } from 'lottie-web';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-shoppinglist',
  templateUrl: './shoppinglist.component.html',
  styleUrls: ['./shoppinglist.component.scss'],
})
export class ShoppinglistComponent implements OnInit, OnDestroy {
  shoppingListItem: shoppingListItemInCategory[];
  groceryCategoryList: groceryCategoryList[];
  unitlist;
  public selectedItem: string[] = [];
  subscriptions: Subscription[] = [];
  isReady: boolean = false;
  showLottie: boolean = false;
  constructor(
    private matBottomSheet: MatBottomSheet,
    private recipeService: RecipeService,
    private cookingStoryShoppinglistDateService: CookingStoryShoppinglistDateService,
    private cookingStoryGroceryService: CookingStoryGroceryService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}
  options: AnimationOptions = {
    path: '/assets/animations/emptyList.json',
    loop: false,
  };
  async ngOnInit() {
    this.cookingStoryShoppinglistDateService.clearshoppingListItems();
    this.inital();
    const selectAll = this.cookingStoryGroceryService.toggleAllItems.subscribe(
      (move) => {
        if (move) {
          this.selectedItem = [];

          this.selectedItem = this.cookingStoryShoppinglistDateService
            .getItems()
            .map((item) => item.id);
        } else {
          this.selectedItem = [];
        }
      }
    );
    const sub = this.cookingStoryShoppinglistDateService.update.subscribe(
      (update) => {
        if (update) {
          this.update();
        }
      }
    );
    const newQA =
      this.cookingStoryShoppinglistDateService.getNewQuickAdd.subscribe(
        (data) => {
          this.getItemsFromServie();
          this.updateSelectdItem();
          let l = 1;
          this.shoppingListItem.map((data) => {
            if (data.foods.length > 0) {
              l += 1;
            }
          });

          if (l == 0) {
            this.showLottie = true;
          } else {
            this.showLottie = false;
          }
        }
      );
    const refetch = this.cookingStoryShoppinglistDateService.refetch.subscribe(
      (data) => {
        this.selectedItem = [];

        this.inital();
        this.updateSelectdItem();
      }
    );
    this.subscriptions.push(sub, newQA, refetch, selectAll);
  }
  async update() {
    this.shoppingListItem =
      await this.cookingStoryShoppinglistDateService.getupdateListItem(
        this.shoppingListItem
      );
    this.updateSelectdItem();
  }
  async inital() {
    this.unitlist =
      await this.cookingStoryShoppinglistDateService.getUnitList();
    this.cookingStoryGroceryService
      .getGroceryCategoryListData()
      .then((data) => {
        this.groceryCategoryList = data
          .getData()
          .getGroceryCategoryRespoce().list;
        this.cookingStoryShoppinglistDateService.saveGroceryCategory(
          this.groceryCategoryList
        );
        this.cookingStoryGroceryService
          .getShoppingListHomeData()
          .then(async (data) => {
            if (
              data.getData().getShoppingListHomeItemResponce().shoppingList
                .length == 0
            ) {
              this.showLottie = true;
            } else {
              this.showLottie = false;
            }
            this.shoppingListItem =
              await this.cookingStoryShoppinglistDateService.addshoppingListItems(
                data.getData().getShoppingListHomeItemResponce().shoppingList
              );
            this.shoppingListItem.map((item) => {
              item.foods.map((selectedItem) => {
                if (selectedItem.quickAdd) {
                  const data = new kitchenSearchItem(
                    null,
                    selectedItem.quickAdd,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    true,
                    selectedItem._id
                  );
                  this.cookingStoryShoppinglistDateService.JustaddItem(data);
                } else {
                  const unit = this.unitlist.filter((d) => {
                    return selectedItem.unit == d._id;
                  })[0];

                  let unitDescription;
                  if (selectedItem.unit && !selectedItem.unitDescription) {
                    unitDescription = unit.name;
                  } else {
                    unitDescription = selectedItem.unitDescription;
                  }
                  const newUnit = new foodUnitRatioArraySample(
                    1,
                    'nothing',
                    'nothing',
                    '',
                    ''
                  );
                  const data = new kitchenSearchItem(
                    (selectedItem.food as FoodModel)._id,
                    null,
                    selectedItem.amount,
                    selectedItem.unit,
                    unitDescription,
                    selectedItem.description,
                    null,
                    (selectedItem.food as FoodModel).name,
                    (selectedItem.food as FoodModel).foodUnitRatioArray as any,
                    true,
                    selectedItem._id
                  );
                  (selectedItem.food as FoodModel).foodUnitRatioArray.push(
                    newUnit as any
                  );
                  this.cookingStoryShoppinglistDateService.JustaddItem(data);
                }
              });
            });
            this.isReady = true;
          });
      });

    this.updateSelectdItem();
  }
  animationCreated(animationItem: AnimationItem): void {}
  async getItemsFromServie() {
    this.shoppingListItem =
      await this.cookingStoryShoppinglistDateService.getAllshoppingListItemInCategory();
  }
  checkSelect(id: string): boolean {
    let item = this.selectedItem.find((x) => x == id);
    if (this.selectedItem.length == 0) {
      this.cookingStoryGroceryService.shoppingListDeslecting.next();
    }
    if (!item) {
      return true;
    } else {
      return false;
    }
  }
  updateSelectdItem() {
    if (this.cookingStoryShoppinglistDateService.getItems().length > 0) {
      const ids = this.cookingStoryShoppinglistDateService
        .getItems()
        .map((x) => x.id);
      let l = 0;
      this.shoppingListItem.map((data) => {
        if (data.foods.length > 0) {
          l += 1;
        }
      });
      if (l == 0) {
        this.showLottie = true;
      } else {
        this.showLottie = false;
      }
      this.selectedItem.map((item, i) => {
        if (!ids.includes(item)) {
          this.selectedItem.splice(i, 1);
        }
      });
    }
  }
  goTosearch() {
    this.recipeService.goToKitchenSearch();
  }
  getFoodName(food: shoppingListItem) {
    if (food.quickAdd && food.quickAdd !== '') {
      return food.quickAdd;
    }
    return (food.food as FoodModel)?.name;
  }
  hadComment(food: shoppingListItem) {
    const is =
      food?.description &&
      this.cookingStoryShoppinglistDateService.getItem(food._id).description !==
        ''
        ? true
        : false;
    return is;
  }
  getFoodUnit(food: shoppingListItem) {
    const amount = food.amount;
    const item = this.cookingStoryShoppinglistDateService.getItem(food._id);
    if (amount && (!item?.unitDescription || item?.unitDescription == '')) {
      return amount;
    }

    if (!food.amount && !item?.unitDescription) {
      return ' ';
    }
    if (!food.amount && item?.unitDescription) {
      return item.unitDescription;
    }

    return amount + ' ' + item.unitDescription;
  }
  toggleSelect(id: string) {
    const ids = this.selectedItem.find((x) => x == id);
    console.log(this.cookingStoryShoppinglistDateService.getItems());

    if (ids) {
      this.selectedItem = this.selectedItem.filter((x) => x !== id);
    } else {
      this.selectedItem.push(id);
    }
    if (this.selectedItem.length == 0) {
      this.cookingStoryGroceryService.shoppingListDeslecting.next();
    }
  }
  openCartBottomSheet() {
    this.cookingStoryShoppinglistDateService.changeType('search');
    this.cookingStoryShoppinglistDateService.changeActiveItem(null);

    const bottomSheetRef = this.matBottomSheet.open(
      KitchenQuickBottomsheetComponent,
      {
        panelClass: 'custom-bottomsheet-container',
      }
    );
    const sub = bottomSheetRef
      .afterDismissed()
      .subscribe((dataFromChild) => {});
    this.subscriptions.push(sub);
  }
  goToSearch() {
    this.recipeService.goToShoppingListSearch();
  }
  openEditCartBottomSheet(food: shoppingListItem) {
    // let food: shoppingListItem;
    // this.shoppingListItem.map((d) => {
    //   food = d.foods.filter((d) => {
    //     return d._id == id;
    //   })[0];
    // });

    this.cookingStoryShoppinglistDateService.changeType('edit');

    const kitchenItem = new kitchenSearchItem(
      (food.food as FoodModel)._id,
      null,
      food.amount,
      null,
      food.unitDescription,
      food.description,
      null,
      (food.food as FoodModel).name,
      (food.food as FoodModel).foodUnitRatioArray as any,

      true,
      food._id
    );
    const data = { food: kitchenItem, id: food._id };
    const bottomSheetRef = this.matBottomSheet.open(
      ShoppingListSearchEditComponent,
      {
        panelClass: 'custom-bottomsheet-container',
        data,
      }
    );
    const sub = bottomSheetRef.afterDismissed().subscribe((dataFromChild) => {
      this.changeDetectorRef.detectChanges();
    });
    this.subscriptions.push(sub);
  }
  async openQuickAddEditBottomSheet(id: string) {
    let selectedItem: shoppingListItem = await this.shoppingListItem.map(
      (d) => {
        return d.foods.find((x) => {
          return x._id == id;
        });
      }
    )[0];

    this.cookingStoryShoppinglistDateService.changeType('edit');

    const kitchenItem = new kitchenSearchItem(
      null,
      selectedItem.quickAdd,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      false,
      selectedItem._id
    );
    const data = { item: kitchenItem, id: selectedItem._id };
    const bottomSheetRef = this.matBottomSheet.open(
      KitchenQuickBottomsheetComponent,
      {
        panelClass: 'custom-bottomsheet-container',
        data,
      }
    );
    const sub = bottomSheetRef.backdropClick().subscribe((dataFromChild) => {});
    this.subscriptions.push(sub);
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
  moveAllToKitchen() {
    if (this.selectedItem.length > 0) {
      const btm = this.matBottomSheet.open(ShoppinglistMoveConfirmComponent, {
        panelClass: 'custom-bottomsheet-container',
        data: this.selectedItem,
      });
      btm.afterDismissed().subscribe(() => {
        this.cookingStoryGroceryService.shoppingListDeslecting.next();
        this.cookingStoryGroceryService.changeTab.next();
      });
    }
  }
  removeAll() {
    if (this.selectedItem.length > 0) {
      this.cookingStoryShoppinglistDateService.deleteSelectedItems(
        this.selectedItem
      );
      this.cookingStoryGroceryService.shoppingListDeslecting.next();
    }
  }
  gArr(l: number) {
    return new Array(l);
  }
}
